import { Rive, Layout, RuntimeLoader } from "@rive-app/canvas";
import riveWasmUrl from "@rive-app/canvas/rive.wasm";

// Serve the runtime from our own server instead of unpkg (Rive still falls back to jsdelivr if this fails)
RuntimeLoader.setWasmUrl(riveWasmUrl);

export function initRiveCanvas(canvas) {
    if (canvas && !canvas.dataset.riveInitialized) {
        canvas.dataset.riveInitialized = "true";
        new Rive({
            src: canvas.dataset.riveSource,
            canvas: canvas,
            autoplay: true,
            layout: new Layout({fit: 'contain', alignment: 'centerRight'}),
        })
    }
}

export function initRive() {
    const riveCanvas = document.querySelectorAll(".rive-animation-canvas.quote");
    // Only download and start an animation once it is about to scroll into view
    const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting && !entry.target.closest('.collapse:not(.show)')) {
                    observer.unobserve(entry.target);
                    initRiveCanvas(entry.target);
                }
            }
        }, {rootMargin: '300px 0px'})
        : null;
    for (const canvas of riveCanvas) {
        if (!canvas.closest('.collapse:not(.show)')) {
            observer ? observer.observe(canvas) : initRiveCanvas(canvas);
        }
    }
}
